// extracted by mini-css-extract-plugin
module.exports = {"drawingTool":"drawingTool__drawingTool___27nV1","canvasWrapper":"drawingTool__canvasWrapper___3PPkx","modalButtonMinimize":"drawingTool__modalButtonMinimize___3NIjI"};